import Vue from 'vue'
import App from './App'
import router from './router'
import excel from "vue-excel-export";

Vue.config.productionTip = false

Vue.use(excel)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})






// WEBPACK FOOTER //
// ./src/main.js